var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import PopperLayer from "./PopperLayer";
var nextToolipId = 1;
var TOOLTIP_ID_PREFIX = "tooltip--";
function defaultRenderTooltip(text) {
    return text;
}
export var TooltipConfigContext = React.createContext({
    renderTooltip: defaultRenderTooltip
});
export default function Tooltip(_a) {
    var children = _a.children, text = _a.text, showDelayMs = _a.showDelayMs, optionsProp = _a.options;
    var domRef = React.useRef(null);
    var idRef = React.useRef(null);
    var _b = React.useContext(TooltipConfigContext), renderTooltip = _b.renderTooltip, optionsContext = _b.options;
    var _c = React.useState(false), showTooltip = _c[0], setShowTooltip = _c[1];
    var showDelayMsRef = React.useRef(showDelayMs);
    React.useEffect(function () { return void (showDelayMsRef.current = showDelayMs); });
    var showTimeoutRef = React.useRef(undefined);
    React.useEffect(function () { return function () {
        if (showTimeoutRef.current != null) {
            clearTimeout(showTimeoutRef.current);
            showTimeoutRef.current = undefined;
        }
    }; }, []);
    var showTooltipMethod = React.useCallback(function () {
        var showDelay = showDelayMsRef.current;
        var show = function () {
            if (idRef.current == null) {
                idRef.current = TOOLTIP_ID_PREFIX + nextToolipId++;
            }
            setShowTooltip(true);
            showTimeoutRef.current = undefined;
        };
        if (showDelay != null) {
            if (showTimeoutRef.current == null) {
                showTimeoutRef.current = window.setTimeout(show, showDelay);
            }
        }
        else {
            show();
        }
    }, []);
    var hideTooltipMethod = React.useCallback(function () {
        if (showTimeoutRef.current != null) {
            clearTimeout(showTimeoutRef.current);
            showTimeoutRef.current = undefined;
        }
        setShowTooltip(false);
    }, []);
    var render = React.useCallback(function (popperProps) { return renderTooltip(text, popperProps); }, [text, renderTooltip]);
    var options = React.useMemo(function () { return (__assign(__assign({ placement: "top" }, optionsContext), optionsProp)); }, [optionsContext, optionsProp]);
    return (React.createElement(React.Fragment, null,
        children({
            onMouseEnter: showTooltipMethod,
            onMouseLeave: hideTooltipMethod,
            onFocus: showTooltipMethod,
            onBlur: hideTooltipMethod,
            "aria-describedby": showTooltip ? idRef.current : undefined,
            ref: domRef
        }),
        showTooltip ? (React.createElement(PopperLayer, { id: idRef.current, reference: domRef, options: options, render: render })) : null));
}
